import WidgetStandings from '@/screens/WidgetStandings';

export default function ExternalWidgetV1StandingsEventIdRoute() {
  return <WidgetStandings />;
}
